<template>
  <base-slide-over ref="filterSlideover" title="Filter Price Change Requests" size="lg" style="z-index: 10000">
    <base-form ref="form" class="tw-py-2.5 tw-px-4 sm:tw-py-4 sm:tw-px-6" @submit.prevent>
      <div class="tw-text-normal tw-font-normal tw-mt-6 tw-mb-2.5">Status</div>
      <base-advanced-select label="Status" placeholder="Select one or more statuses" :options="statusOptions" v-model="statusFilter" label-key="label" multiple />

      <div class="tw-text-normal tw-font-normal tw-mb-2.5 tw-mt-6">Locations</div>
      <base-advanced-select label="Locations" placeholder="Select one or more locations" :options="orderedLocations" v-model="locationsFilter" label-key="name" multiple />

      <div class="tw-text-normal tw-font-normal tw-mb-2.5 tw-mt-6">Programs</div>

      <base-advanced-select label="Programs" placeholder="Select one or more programs" :options="orderedPrograms" label-key="name" v-model="programFilter" multiple />
    </base-form>
    <template #fixed-bottom>
      <div class="tw-p-3 tw-flex tw-justify-between">
        <base-button type="flat" color="red" class="tw-w-auto tw-mr-2" @click="clearFilters">
          Clear All
        </base-button>
        <div>
          <base-button type="flat" class="tw-w-auto tw-mr-2" @click="$refs.filterSlideover.hide()">
            Cancel
          </base-button>
          <base-button class="tw-w-auto" @click="applyFilter">
            Apply
          </base-button>
        </div>
      </div>
    </template>
  </base-slide-over>
</template>

<script>
import { mapGetters } from "vuex";
const PRICE_CHANGE_REQUEST_STATUS_OPTIONS = [{ label: "Requested", value: "requested" }, { label: "Approved", value: "approved" }, { label: "Rejected", value: "rejected" }];

export default {
  name: "BusinessProgramPriceChangeFilter",
  props: {
    businessId: { type: String, required: true },
    allPrograms: { type: Array, required: true },
  },

  data() {
    return {
      locationsFilter: [],
      programFilter: [],
      statusFilter: [],
      statusOptions: PRICE_CHANGE_REQUEST_STATUS_OPTIONS,
    };
  },
  computed: {
    ...mapGetters("location", ["locations"]),
    orderedLocations() {
      return this.locations.slice().sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
    },
    orderedPrograms() {
      const uniqueProgramNames = Array.from(new Set(this.allPrograms.map((p) => p.name)))
        .slice()
        .sort((a, b) => (a > b ? 1 : b > a ? -1 : 0));

      return uniqueProgramNames.map((p) => {
        return { name: p };
      });
    },
  },
  methods: {
    show() {
      this.$refs.filterSlideover.show();
    },
    hide() {
      this.$refs.filterSlideover.hide();
    },
    clearFilters() {
      this.reset();
      this.applyFilter();
    },
    reset() {
      this.locationsFilter = [];
      this.programFilter = [];
      this.statusFilter = [];
      if (this.$refs.dateToggle) {
        this.$refs.dateToggle.clearSelection();
      }
    },
    applyFilter() {
      let locationFilterIds = this.locationsFilter.map((item) => item.businessLocationId);
      let programFilterNames = this.programFilter.map((item) => item.name);
      let statusFilterValues = this.statusFilter.map((item) => item.value);

      this.$emit("filter-updated", {
        locationsFilter: locationFilterIds,
        programFilter: programFilterNames,
        statusFilter: statusFilterValues,
      });

      this.hide();
    },
  },
};
</script>
